import React, { useState } from 'react';

function App() {
  // Estado para el formulario de registro de la Tómbola Perrona
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    folio: ''
  });
  const [registeredTicket, setRegisteredTicket] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('todos');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.folio) {
      alert('Por favor ingresa al menos tu nombre y tu folio de boleto.');
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      setRegisteredTicket({
        ...formData,
        raffleCode: `XOLO-${Math.floor(1000 + Math.random() * 9000)}`,
        fechaRegistro: new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })
      });
      setIsSubmitting(false);
    }, 600);
  };

  const resetForm = () => {
    setRegisteredTicket(null);
    setFormData({ nombre: '', email: '', telefono: '', folio: '' });
  };

  const autofillDemo = (tipo) => {
    if (tipo === 'general') {
      setFormData({
        nombre: 'Carlos Mendoza',
        email: 'carlos@xolos.com.mx',
        telefono: '664 123 4567',
        folio: 'XOLO-0428'
      });
    } else {
      setFormData({
        nombre: 'Valeria Rojinegra',
        email: 'valeria@jauria.mx',
        telefono: '664 987 6543',
        folio: 'VIP-0089'
      });
    }
  };

  return (
    <div className="app-wrapper">
      {/* NAVBAR */}
      <nav className="navbar-xolo">
        <div className="container py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <div className="xolo-logo-badge">
                <i className="bi bi-shield-fill text-danger fs-3"></i>
              </div>
              <div>
                <span className="brand-title">XOLO FEST</span>
                <span className="brand-edition">2026</span>
                <p className="brand-subtitle d-none d-sm-block">Club Tijuana Xoloitzcuintles • Estadio Caliente</p>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2 gap-md-3">
              <a href="#experiencias" className="nav-link-custom d-none d-md-inline-block">
                Experiencias
              </a>
              <a href="#tombola" className="nav-link-custom d-none d-md-inline-block">
                Tómbola Perrona
              </a>
              <a href="#ubicacion" className="nav-link-custom d-none d-lg-inline-block">
                Ubicación
              </a>
              <a href="#registro" className="btn btn-xolo-primary btn-sm">
                <i className="bi bi-ticket-perforated-fill me-1"></i> Registrar Boleto
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* HERO SECTION */}
      <section className="hero-section text-center">
        <div className="container position-relative z-1">
          <div className="hero-pill mb-3">
            <i className="bi bi-fire text-warning me-1"></i>
            La Gran Fiesta Oficial de la Jauría Rojinegra
          </div>

          <h1 className="hero-title mb-3">
            Vive la Pasión de Xolos <br />
            <span className="hero-title-highlight">Como Nunca Antes</span>
          </h1>

          <p className="hero-lead mb-4 mx-auto">
            El festival que reúne a toda la afición de Tijuana en una jornada épica: música en vivo,
            la mejor gastronomía de Baja California, convivencia con jugadores y leyendas del club,
            retos interactivos y la gran <strong>Tómbola Perrona</strong>.
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
            <a href="#registro" className="btn btn-xolo-primary btn-lg px-4">
              <i className="bi bi-qr-code-scan me-2"></i> Activar Mi Boleto
            </a>
            <a href="#experiencias" className="btn btn-xolo-outline btn-lg px-4">
              <i className="bi bi-stars me-2"></i> Ver Actividades
            </a>
          </div>

          {/* HIGHLIGHTS BAR */}
          <div className="row g-3 justify-content-center text-start">
            <div className="col-6 col-md-3">
              <div className="highlight-stat-card">
                <i className="bi bi-geo-alt-fill text-danger fs-4 mb-2"></i>
                <div className="stat-title">Estadio Caliente</div>
                <div className="stat-desc">Tijuana, Baja California</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="highlight-stat-card">
                <i className="bi bi-people-fill text-warning fs-4 mb-2"></i>
                <div className="stat-title">100% Familiar</div>
                <div className="stat-desc">Para todas las edades</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="highlight-stat-card">
                <i className="bi bi-trophy-fill text-danger fs-4 mb-2"></i>
                <div className="stat-title">Tómbola Perrona</div>
                <div className="stat-desc">Premios y viajes exclusivos</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="highlight-stat-card">
                <i className="bi bi-phone-fill text-warning fs-4 mb-2"></i>
                <div className="stat-title">Pasaporte Digital</div>
                <div className="stat-desc">Acceso ágil sin filas</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN EXPERIENCIAS */}
      <section id="experiencias" className="py-5 experiences-section">
        <div className="container py-4">
          <div className="text-center mb-5">
            <span className="section-pill">¿Qué Vivirás?</span>
            <h2 className="section-title text-white mt-2">Una Experiencia Inolvidable</h2>
            <p className="section-lead mx-auto">
              Todo el espíritu rojinegro concentrado en un solo lugar con dinámicas diseñadas para ti y tu familia.
            </p>

            {/* Filtros de Categoría */}
            <div className="d-flex justify-content-center flex-wrap gap-2 mt-4">
              <button
                className={`filter-btn ${activeTab === 'todos' ? 'active' : ''}`}
                onClick={() => setActiveTab('todos')}
              >
                Todas las Áreas
              </button>
              <button
                className={`filter-btn ${activeTab === 'musica' ? 'active' : ''}`}
                onClick={() => setActiveTab('musica')}
              >
                Música & Shows
              </button>
              <button
                className={`filter-btn ${activeTab === 'gastro' ? 'active' : ''}`}
                onClick={() => setActiveTab('gastro')}
              >
                Gastronomía
              </button>
              <button
                className={`filter-btn ${activeTab === 'xolos' ? 'active' : ''}`}
                onClick={() => setActiveTab('xolos')}
              >
                Experiencia Club
              </button>
            </div>
          </div>

          <div className="row g-4">
            {/* Card 1 */}
            {(activeTab === 'todos' || activeTab === 'musica') && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card-experience">
                  <div className="card-icon-wrapper music-bg">
                    <i className="bi bi-music-note-beamed"></i>
                  </div>
                  <span className="card-category text-warning">Escenario Caliente</span>
                  <h3 className="card-title">Conciertos & Música en Vivo</h3>
                  <p className="card-text">
                    Bandas locales, talento nacional y DJ sets continuos para mantener el ambiente al máximo en el escenario principal.
                  </p>
                  <div className="card-footer-badge">
                    <i className="bi bi-clock me-1"></i> Todo el día
                  </div>
                </div>
              </div>
            )}

            {/* Card 2 */}
            {(activeTab === 'todos' || activeTab === 'gastro') && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card-experience">
                  <div className="card-icon-wrapper gastro-bg">
                    <i className="bi bi-cup-hot-fill"></i>
                  </div>
                  <span className="card-category text-danger">Baja Med & Food Trucks</span>
                  <h3 className="card-title">Zona Gastronómica Perrona</h3>
                  <p className="card-text">
                    Los mejores tacos de Tijuana, cocina urbana bajacaliforniana, snacks temáticos y barra de cerveza artesanal de la región.
                  </p>
                  <div className="card-footer-badge">
                    <i className="bi bi-shop me-1"></i> +25 Stands y Food Trucks
                  </div>
                </div>
              </div>
            )}

            {/* Card 3 */}
            {(activeTab === 'todos' || activeTab === 'xolos') && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card-experience">
                  <div className="card-icon-wrapper xolos-bg">
                    <i className="bi bi-award-fill"></i>
                  </div>
                  <span className="card-category text-warning">Convivencia Exclusiva</span>
                  <h3 className="card-title">Firma de Autógrafos & Leyendas</h3>
                  <p className="card-text">
                    Conoce de cerca a los jugadores del primer equipo varonil y femenil, tómate fotos con el Xolo Mayor y convive con figuras históricas.
                  </p>
                  <div className="card-footer-badge">
                    <i className="bi bi-camera-fill me-1"></i> Zona Fan Zone
                  </div>
                </div>
              </div>
            )}

            {/* Card 4 */}
            {(activeTab === 'todos' || activeTab === 'xolos') && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card-experience">
                  <div className="card-icon-wrapper games-bg">
                    <i className="bi bi-controller"></i>
                  </div>
                  <span className="card-category text-danger">Retos & Dinámicas</span>
                  <h3 className="card-title">Reto de Habilidades & eSports</h3>
                  <p className="card-text">
                    Demuestra tu puntería en el Tiro al Blanco Caliente, participa en torneos rápidos de videojuegos y gana premios al instante.
                  </p>
                  <div className="card-footer-badge">
                    <i className="bi bi-dpad-fill me-1"></i> Premios en vivo
                  </div>
                </div>
              </div>
            )}

            {/* Card 5 */}
            {(activeTab === 'todos' || activeTab === 'xolos') && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card-experience">
                  <div className="card-icon-wrapper kids-bg">
                    <i className="bi bi-emoji-smile-fill"></i>
                  </div>
                  <span className="card-category text-warning">Para los Pequeños</span>
                  <h3 className="card-title">Zona Xolokids & Inflables</h3>
                  <p className="card-text">
                    Espacio seguro y divertido para los pequeños aficionados con inflables gigantes, pintacaritas rojinegro y minitorneos.
                  </p>
                  <div className="card-footer-badge">
                    <i className="bi bi-shield-check me-1"></i> Área protegida
                  </div>
                </div>
              </div>
            )}

            {/* Card 6 */}
            {(activeTab === 'todos' || activeTab === 'xolos') && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card-experience">
                  <div className="card-icon-wrapper merch-bg">
                    <i className="bi bi-bag-check-fill"></i>
                  </div>
                  <span className="card-category text-danger">XoloShop Oficial</span>
                  <h3 className="card-title">Tienda Oficial & Descuentos</h3>
                  <p className="card-text">
                    Adquiere jerseys oficiales con personalización gratuita en el evento, souvenirs conmemorativos y ediciones de colección de Xolo Fest.
                  </p>
                  <div className="card-footer-badge">
                    <i className="bi bi-percent me-1"></i> Descuentos exclusivos
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* SECCIÓN TÓMBOLA PERRONA & REGISTRO */}
      <section id="registro" className="py-5 tombola-section">
        <div className="container py-4">
          <div className="row align-items-center g-5">
            {/* Columna Informativa */}
            <div className="col-12 col-lg-6">
              <span className="section-pill mb-2">
                <i className="bi bi-gift-fill me-1"></i> Sorteo Oficial
              </span>
              <h2 className="section-title text-white mt-2">
                La Gran Tómbola Perrona 🎰
              </h2>
              <p className="text-secondary fs-5 mt-3 mb-4">
                Todos los asistentes con boleto registrado participan en el sorteo más grande del año.
                Al registrar tu boleto aquí, aseguras tu folio oficial para ganar premios increíbles en el escenario principal.
              </p>

              <div className="d-flex flex-column gap-3 mb-4">
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="bi bi-star-fill text-warning"></i>
                  </div>
                  <div>
                    <h4 className="benefit-title">Abonos de Temporada</h4>
                    <p className="benefit-desc">Pases dobles para todo el torneo en el Estadio Caliente.</p>
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="bi bi-airplane-fill text-danger"></i>
                  </div>
                  <div>
                    <h4 className="benefit-title">Viaje con el Equipo</h4>
                    <p className="benefit-desc">Acompaña a la Jauría a un partido de visitante con todo pagado.</p>
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="bi bi-tag-fill text-warning"></i>
                  </div>
                  <div>
                    <h4 className="benefit-title">Jerseys Autografiados</h4>
                    <p className="benefit-desc">Uniformes oficiales firmados por el plantel completo.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Columna Formulario / Pasaporte */}
            <div className="col-12 col-lg-6">
              <div id="tombola" className="ticket-form-card">
                {!registeredTicket ? (
                  <>
                    <div className="d-flex align-items-center justify-content-between mb-4 border-bottom border-secondary border-opacity-25 pb-3">
                      <div>
                        <h3 className="h4 text-white fw-bold mb-1">Registra tu Boleto</h3>
                        <p className="text-secondary small mb-0">Ingresa tus datos y activa tu folio de sorteo</p>
                      </div>
                      <span className="badge bg-danger px-3 py-2 fw-semibold">
                        <i className="bi bi-lightning-charge-fill me-1"></i> 1 Paso
                      </span>
                    </div>

                    {/* Botones de prueba demo rápida */}
                    <div className="demo-helper-box mb-4">
                      <span className="small text-secondary fw-semibold d-block mb-2">
                        <i className="bi bi-magic me-1 text-warning"></i> ¿Quieres probar rápido? Autocompleta un boleto demo:
                      </span>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary text-light flex-grow-1"
                          onClick={() => autofillDemo('general')}
                        >
                          Boleto General
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary text-light flex-grow-1"
                          onClick={() => autofillDemo('vip')}
                        >
                          Boleto VIP
                        </button>
                      </div>
                    </div>

                    <form onSubmit={handleRegister}>
                      <div className="mb-3">
                        <label className="form-label text-light small fw-semibold">Nombre Completo</label>
                        <div className="input-group">
                          <span className="input-group-text bg-dark border-secondary border-opacity-50 text-secondary">
                            <i className="bi bi-person-fill"></i>
                          </span>
                          <input
                            type="text"
                            name="nombre"
                            className="form-control form-control-dark"
                            placeholder="Ej. Juan Pérez"
                            value={formData.nombre}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="row g-3 mb-3">
                        <div className="col-12 col-sm-6">
                          <label className="form-label text-light small fw-semibold">Correo Electrónico</label>
                          <div className="input-group">
                            <span className="input-group-text bg-dark border-secondary border-opacity-50 text-secondary">
                              <i className="bi bi-envelope-fill"></i>
                            </span>
                            <input
                              type="email"
                              name="email"
                              className="form-control form-control-dark"
                              placeholder="correo@ejemplo.com"
                              value={formData.email}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-6">
                          <label className="form-label text-light small fw-semibold">Teléfono / WhatsApp</label>
                          <div className="input-group">
                            <span className="input-group-text bg-dark border-secondary border-opacity-50 text-secondary">
                              <i className="bi bi-whatsapp"></i>
                            </span>
                            <input
                              type="tel"
                              name="telefono"
                              className="form-control form-control-dark"
                              placeholder="(664) 000-0000"
                              value={formData.telefono}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="form-label text-light small fw-semibold">Folio de Boleto</label>
                        <div className="input-group">
                          <span className="input-group-text bg-dark border-secondary border-opacity-50 text-secondary">
                            <i className="bi bi-ticket-detailed-fill"></i>
                          </span>
                          <input
                            type="text"
                            name="folio"
                            className="form-control form-control-dark text-uppercase font-monospace"
                            placeholder="Ej. XOLO-0042 o VIP-0100"
                            value={formData.folio}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <small className="text-secondary mt-1 d-block">
                          Encuentra el folio impreso en tu boleto físico o en tu comprobante digital.
                        </small>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-xolo-primary w-100 py-3 fw-bold fs-6"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <span>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Inscribiendo...
                          </span>
                        ) : (
                          <span>
                            <i className="bi bi-trophy-fill me-2 text-warning"></i>
                            Inscribirme a la Tómbola Perrona
                          </span>
                        )}
                      </button>
                    </form>
                  </>
                ) : (
                  /* Tarjeta Confirmación de Pasaporte */
                  <div className="registered-ticket-view text-center py-2">
                    <div className="confetti-badge mb-3">
                      <i className="bi bi-check-circle-fill text-success fs-1"></i>
                    </div>

                    <h3 className="h3 text-white fw-bold">¡Boleto Registrado con Éxito!</h3>
                    <p className="text-secondary mb-4">
                      Ya estás participando formalmente en la gran <strong>Tómbola Perrona</strong>.
                    </p>

                    <div className="raffle-ticket-badge mb-4">
                      <span className="raffle-label">Tu Folio Oficial de Sorteo:</span>
                      <div className="raffle-code">{registeredTicket.raffleCode}</div>
                      <div className="raffle-meta">
                        <span>Titular: <strong>{registeredTicket.nombre}</strong></span>
                        <span className="mx-2">•</span>
                        <span>Boleto: <strong>{registeredTicket.folio}</strong></span>
                      </div>
                    </div>

                    <div className="passport-preview-box mb-4 text-start">
                      <div className="d-flex align-items-center gap-3">
                        <i className="bi bi-qr-code text-warning fs-1"></i>
                        <div>
                          <div className="text-light fw-bold">Pasaporte Digital Activado</div>
                          <small className="text-secondary">
                            Presenta tu folio o código al ingresar al Estadio Caliente para acumular sellos de actividades.
                          </small>
                        </div>
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn btn-outline-secondary text-light w-100 py-2"
                      onClick={resetForm}
                    >
                      <i className="bi bi-arrow-left me-1"></i> Registrar otro boleto
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN UBICACIÓN & CONTACTO */}
      <section id="ubicacion" className="py-5 location-section">
        <div className="container py-4">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-md-6">
              <span className="section-pill mb-2">Sede Oficial</span>
              <h2 className="section-title text-white mt-2">Estadio Caliente</h2>
              <p className="text-secondary fs-5 mt-3 mb-4">
                La casa de los Xoloitzcuintles abre sus puertas para recibir a miles de aficionados
                en la explanada central, zona de palcos, corredores gastronómicos y campo.
              </p>

              <div className="d-flex flex-column gap-3 text-light">
                <div className="d-flex align-items-center gap-3">
                  <div className="location-icon">
                    <i className="bi bi-pin-map-fill text-danger"></i>
                  </div>
                  <div>
                    <strong>Dirección:</strong>
                    <div className="text-secondary">Blvd. Agua Caliente 12027, Hipódromo, 22020 Tijuana, B.C.</div>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-3">
                  <div className="location-icon">
                    <i className="bi bi-car-front-fill text-warning"></i>
                  </div>
                  <div>
                    <strong>Estacionamiento:</strong>
                    <div className="text-secondary">Estacionamiento oficial disponible con acceso por Blvd. Aguacaliente.</div>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-3">
                  <div className="location-icon">
                    <i className="bi bi-shield-check text-success"></i>
                  </div>
                  <div>
                    <strong>Seguridad & Acceso:</strong>
                    <div className="text-secondary">Protocolos de Protección Civil y filtros perimetrales amigables.</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="stadium-card">
                <div className="stadium-card-header">
                  <span className="badge bg-danger">Mística Xoloitzcuintle</span>
                  <span className="text-warning small fw-bold">Tijuana, México</span>
                </div>
                <div className="stadium-graphic py-5 text-center">
                  <i className="bi bi-shield-shaded display-1 text-danger opacity-75"></i>
                  <h3 className="h4 text-white mt-3 fw-bold">MÁS QUE UN FESTIVAL</h3>
                  <p className="text-secondary px-4 mb-0 small">
                    Una fiesta pensada por y para la comunidad de Tijuana. ¡Nos vemos en el Estadio Caliente!
                  </p>
                </div>
                <div className="stadium-card-footer text-center py-3">
                  <span className="text-light small">
                    <i className="bi bi-ticket-detailed me-1 text-warning"></i>
                    Entrada libre con boleto oficial de festival
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER INSTITUCIONAL */}
      <footer className="footer-xolo py-4">
        <div className="container">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
            <div className="d-flex align-items-center gap-3">
              <div className="xolo-logo-badge small-badge">
                <i className="bi bi-shield-fill text-danger fs-5"></i>
              </div>
              <div>
                <div className="text-white fw-bold">XOLO FEST 2026</div>
                <small className="text-secondary">Club Tijuana Xoloitzcuintles de Caliente</small>
              </div>
            </div>

            <div className="text-center text-md-end text-secondary small">
              <div>Sitio Oficial de la Experiencia Xolo Fest</div>
              <div>© 2026 Club Tijuana Xolos. Desarrollado en colaboración con Five Digital Minds.</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
